import { useState, type MouseEvent as ReactMouseEvent, type ReactNode } from "react";
import type { MemoPreview } from "@/api";
import { MemoDetailModal } from "./MemoDetailModal";
import { MemoIcon } from "./MemoIcon";
import { truncateMemo } from "./memoFormatters";
import styles from "./MemoCardPreview.module.css";

// 그리드 카드에 표시하는 최근 메모 한 줄이다. 카드 클릭은 상세를 열므로, stopPropagation 으로
// 클릭을 막고 메모 모달을 연다. 메모가 없으면 "메모 추가" 안내를 그려 작성 진입점을 제공한다.
// 작성/삭제 후 목록 갱신은 모달의 controller 가 ListRefresh 컨텍스트로 처리한다.
export function MemoCardPreview({
  datasetUuid,
  latest,
  count = 0,
}: {
  datasetUuid: string;
  latest?: MemoPreview | null;
  count?: number;
}): ReactNode {
  const [open, setOpen] = useState(false);

  function handleOpen(event: ReactMouseEvent<HTMLButtonElement>): void {
    event.stopPropagation();
    setOpen(true);
  }

  return (
    <>
      <button
        type="button"
        className={styles.preview}
        onClick={handleOpen}
        title="메모를 보거나 작성합니다."
      >
        <span className={styles.icon} aria-hidden="true">
          <MemoIcon />
        </span>
        {latest ? (
          <span className={styles.text}>
            <span className={styles.author}>{latest.author_name}</span>
            <span className={styles.content}>{truncateMemo(latest.content, 40)}</span>
          </span>
        ) : (
          <span className={styles.empty}>메모 추가</span>
        )}
        {count > 1 ? <span className={styles.count}>+{count - 1}</span> : null}
      </button>
      <MemoDetailModal open={open} datasetUuid={datasetUuid} onClose={() => setOpen(false)} />
    </>
  );
}
